module.exports = "#content {\n  margin: auto;\n  width: 50%;\n  padding: 10px;\n  text-align: center; }\n\n#wrongCredentials,\n#errorOccurred {\n  width: 300px;\n  margin: 10px auto auto auto; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/login-keycloak/login-keycloak.component.scss
// module id = ./src/app/login-keycloak/login-keycloak.component.scss
// module chunks = main